import { thoughtActivityCopy } from './thoughtActivityKinds'
import { STREAM_STATUS, TERMINAL_SUMMARIES } from './thoughtActivityStatus'

export function readyStep(thoughtSummary, streaming, phaseTitles) {
  const title = String(thoughtSummary ?? '').trim()
  if (!title || streaming || STREAM_STATUS.has(title) || phaseTitles.includes(title)) {
    return null
  }
  if (!TERMINAL_SUMMARIES.has(title)) return null
  const copy = thoughtActivityCopy('ready')
  return { kind: 'summary', id: 'summary', category: 'ready', title: copy.title }
}

export function composeStep({
  streaming,
  thoughtSummary,
  phaseKinds,
  phaseTitles,
  hasResponseText,
}) {
  if (!streaming) return null
  const hasCompose =
    phaseKinds.some((kind) => kind === 'compose' || kind === 'document') ||
    phaseTitles.some((title) => /writing|draft|preparing.*file/i.test(title))
  if (hasCompose) return null
  if (thoughtSummary !== 'Writing answer...' && !hasResponseText) return null
  const copy = thoughtActivityCopy('compose')
  return {
    kind: 'summary',
    id: 'compose',
    category: 'compose',
    title: copy.title,
    body: copy.explanation,
    running: true,
  }
}
